import {z} from 'zod';

export const BranchPreselectionSchema = z.enum(['SELECTED_BRANCH', 'VEHICLE_BRANCH']);

export const BranchPreselectionSettingsSchema = z.object({
  branchPreselection: BranchPreselectionSchema,
});

export type BranchPreselection = z.infer<typeof BranchPreselectionSchema>;
export type BranchPreselectionSettings = z.infer<typeof BranchPreselectionSettingsSchema>;

// The record created from the vehicle card; also the settings path segment of its preference
export type BranchPreselectionRecordType = 'business-case' | 'interest';

export type GetBranchPreselectionApiArg = {
  recordType: BranchPreselectionRecordType;
};

export type PutBranchPreselectionApiArg = {
  recordType: BranchPreselectionRecordType;
  branchPreselectionSettingsRequestBody: BranchPreselectionSettings;
};
